import { useTranslation } from 'react-i18next'
import { Loader, ToggleSwitch } from 'packages/eid-ui'
import { Box, Typography, styled } from '@mui/material'

const SwitchContainer = styled(({ value, ...rest }) => <Box {...rest} />)(
    ({ value }) => ({
        display: 'flex',
        alignItems: 'center',
        height: '1.5rem',
        '& >p': {
            fontSize: '14px',
        },
        '& .Label': {
            color: value ? '#8b909a' : '#000000',
        },
        '& .SubLabel': {
            color: value ? '#000000' : '#8b909a',
        },
        '& .MuiFormControlLabel-root': {
            marginLeft: '10px',
        },
    }),
)
const DynamicToggleSwitch = ({
    value,
    onChange,
    leftLabelKey,
    rightLabelKey,
    sxProp,
    loading,
    disabled,
}) => {
    const { t } = useTranslation()
    return (
        <SwitchContainer value={value}>
            <Typography className="Label">{t(leftLabelKey)}</Typography>
            {loading ? (
                <Box sx={{ px: 2 }}>
                    <Loader />
                </Box>
            ) : (
                <ToggleSwitch
                    value={value}
                    onChange={(e) => {
                        onChange && onChange(e.target.checked)
                    }}
                    sx={{ ...sxProp }}
                    disabled={disabled}
                />
            )}

            <Typography className="SubLabel">{t(rightLabelKey)}</Typography>
        </SwitchContainer>
    )
}
export default DynamicToggleSwitch
